import { motion } from "framer-motion";

/**
 * Full-screen web page (e.g. the Rafed planning dashboard), shown via
 * page.show. Only works for sites that allow framing -- no X-Frame-Options
 * DENY/SAMEORIGIN and no CSP frame-ancestors. The title chip is
 * pointer-events-none so the page stays fully clickable/scrollable.
 */
export function WebScreen({ url, title, preview = false }: { url: string; title: string; preview?: boolean }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="relative h-full w-full bg-white"
    >
      <iframe
        title={title || "صفحة"}
        src={url}
        className="h-full w-full border-0"
        allow={preview ? "autoplay 'none'; camera 'none'; microphone 'none'" : "fullscreen"}
        allowFullScreen
        referrerPolicy="strict-origin-when-cross-origin"
      />
      {!preview && <a href={url} target="_blank" rel="noopener noreferrer"
        className="absolute bottom-6 left-6 rounded-full bg-slate-900 px-4 py-2 text-sm text-white"
        dir="rtl">الصفحة لا تظهر؟ افتحها في نافذة مستقلة ↗</a>}
      {title && (
        <div
          className="pointer-events-none absolute bottom-6 right-6 rounded-full
                     border border-line bg-ink-2/85 px-5 py-2 text-base font-bold
                     text-fg shadow-2xl backdrop-blur-md"
        >
          {title}
        </div>
      )}
    </motion.div>
  );
}
